<template>
  <external-account-from @save="addAccount" />
</template>
<script>
import ExternalAccountFrom from './Form.vue'

export default {
  name: 'AddExternalAccount',
  components: { ExternalAccountFrom },
  methods: {
    addAccount(account) {
      this.$store
        .dispatch('externalAccount/addAccount', account)
        .then(() => {
          this.$router.push({ name: 'external-accounts' })
        })
        .catch(err => this.errorToast(err.response?.data?.errors || 'Something went wrong while adding external account.'))
    },
  },
}
</script>
